import { useState } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AddIcon } from 'foundations-assets';
import { Select } from 'foundations-components/transitional/components/Select';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { connect } from 'react-redux';
import * as formsSelectors from 'ContentData/selectors/forms';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = (state, props) => {
  const getContactPropertiesAsOptions = formsSelectors.makeGetContactPropertiesAsOptions(props.formDefinition);
  return {
    propertyOptions: getContactPropertiesAsOptions(state)
  };
};
const mapDispatchToProps = {};
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.${key}`;
const PropertySelect = ({
  useOnDark,
  onChange,
  options
}) => /*#__PURE__*/_jsx(Select, {
  "data-selenium": "form-field-add-property-select",
  onChange: ({
    target: {
      value
    }
  }) => onChange(value),
  options: options,
  placeholder: unescapedText(i18nKey('propertySelect.label')),
  buttonUse: useOnDark ? 'form-on-dark' : 'form'
});
const CancelButton = ({
  onClick
}) => /*#__PURE__*/_jsx(Button, {
  "data-selenium": "form-field-add-cancel-button",
  use: "tertiary",
  size: "extra-small",
  onClick: onClick,
  marginBlockStart: "200",
  marginInlineStart: "0",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('addFormField.cancel')
  })
});
const AddFieldButton = ({
  onClick,
  readOnly
}) => /*#__PURE__*/_jsx(Button, {
  "data-selenium": "form-field-add-button",
  disabled: readOnly,
  onClick: onClick,
  size: "extra-small",
  use: "transparent",
  children: /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "100",
    children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('addFormField.label')
    })]
  })
});
const connector = connect(mapStateToProps, mapDispatchToProps);
const AddField = ({
  onSelectProperty = () => {},
  propertyOptions = [],
  useOnDark = false,
  readOnly = false
}) => {
  const [isAdding, setIsAdding] = useState(false);
  const onSelect = property => {
    setIsAdding(false);
    onSelectProperty(property);
  };
  return isAdding ? /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(PropertySelect, {
      useOnDark: useOnDark,
      onChange: onSelect,
      options: propertyOptions
    }), /*#__PURE__*/_jsx(CancelButton, {
      onClick: () => setIsAdding(false)
    })]
  }) : /*#__PURE__*/_jsx(AddFieldButton, {
    onClick: () => setIsAdding(true),
    readOnly: readOnly
  });
};
export default connector(AddField);